import CurrencyConverter from "./components/CurrencyConverter";

function App() {
  return (
    <div className="main">
      <CurrencyConverter />
    </div>
  )
}

export default App;
